<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- LIVE WEBINARS -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Upcoming Live CE Webinars</span>
                </div>
              </b-col>
            </b-row>
            <searchbar v-model="searchModel" @remove-filter="removeFilter"></searchbar>
            <b-row v-if="!noResults">
              <b-col cols="12">
                <span class="txt-section-subtitle red">Available Now: {{totalRows | prettyNumber}} Live Webinars</span>
              </b-col>
            </b-row>
            <b-row v-if="isFiltered && !noResults">
              <b-col cols="12" class="text-left">
                <b-link @click.prevent="searchAllContent">Show All Related Content &raquo;</b-link>
              </b-col>
            </b-row>
          </div>

          <b-alert v-model="noResults" class="mt-3" variant="info">
            No results found for this search.
          </b-alert>

          <!-- TBD classList component. -->
          <div class="div-section-body pb-2" v-if="!noResults">

            <div v-for="(row,ix) in webinars" ref="rows" v-bind:key="row.classId">

              <div v-if="showMobileAd(ix)">
                <mobilead :mb="getMobileAd(ix)"></mobilead>
              </div>
              <b-row class="mt-3 pointer" @click.prevent="gotoWebinar(row)">
                <b-col cols="4">
                  <div class="text-center">
                    <b-img fluid v-bind:src="row.photo" />
                    <div v-if="row.isReserved" class="reserved">RESERVED</div>
                    <div v-if="row.isWaiting" class="waitlist">WAITLIST</div>
                  </div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                  <div class="class-title">{{row.className}}</div>
                  <div class="class-details">
                    {{row.speakerName}}
                    <br>{{row.sponsorCompanyName}}
                    <span class="red">
                      <br>{{row.releaseDateUTC | prettyDateTime}}
                      <br>{{row.credits}} CEU ({{row.creditName}})
                    </span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils"

export default {
  name: "Upcoming",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      studentHash: this.$root.getToken(),
      msg: "Upcoming Webinars",
      blurb: "Upcoming: 0",
      webinars: [],
      mobileAds: null,
      adIndexArr: [],  // indexer into mobileAds.banners[]
      seats: [],   // class Id values of reserved seats
      totalRows: 0,
      pages: 0,
      searchModel: {
        path: '/webinars',
        label: 'Search Live Webinars',
        catId: this.$route.query.cid || null,
        compId: this.$route.query.coid || null,
        query: this.$route.query.q || null
      }
    }
  },
  props: {
    page: {
      type:String,
      required: false,
      default: "0"
    }
  },
  computed: {
    rows () {
      return this.webinars.length
    },
    noResults() {
      return (this.webinars.length == 0)
    },
    isFiltered() {   // return true if page is filtered
      let aout =  (this.searchModel.catId != null)
        || (this.searchModel.compId != null)
        || (this.searchModel.query != null)
      return aout
    }
  },
  methods: {
    gotoWebinar(row) {
      if (row.isReserved || row.isWaiting) {
        this.$router.push(`/live/${row.hash}`)
      }
      else {
        this.$router.push(`/reserve/${row.hash}`)
      }
    },
    removeFilter() {
      this.searchModel.catId = null
      this.searchModel.compId = null
      this.searchModel.query = null
      this.doLive()
    },
    searchAllContent() {
      this.$router.push({ path: '/search', query: {cid: this.searchModel.catId, coid: this.searchModel.compId, q: this.searchModel.query }})
    },
    showMobileAd(ix) { // returns boolean indicating whether slot has mobile ad
      return this.adIndexArr[ix] !== -1
    },
    getMobileAd(ix) {
      let aout = {adId: 0, adUrls: []}
      if (this.adIndexArr[ix] != -1) {
        aout = this.mobileAds.banners[this.adIndexArr[ix]]
      }
      // console.log(aout)
      return aout
    },
    doLive() {
      this.loading = true
      this.webinars = []

      service
        .getUpcoming(this.studentHash, this.searchModel.catId, this.searchModel.compId, this.searchModel.query, this.page)
        .then( res => {
          if (this.debug) console.log(res);
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Upcoming Live Webinars: ${res.rowCount}`
            this.webinars = res.data
            this.totalRows = res.totalRows
            this.seats = res.seats
            // console.log('seats'); console.log(this.seats)
            this.webinars.forEach( (row,ix) => this.webinars[ix].isReserved = row.hasSeat && !row.isWaiting )

            this.mobileAds = (res.mobileAds) ? res.mobileAds : {indexStart:0, interval: 0, rows: 0, banners: []}
            this.adIndexArr = utils.getAdIndexArray( this.webinars.length, this.mobileAds.banners.length, this.mobileAds.indexStart, this.mobileAds.interval )

            // below works too, but doesn't need seats[]
            // this.webinars.forEach( (row,ix) => this.webinars[ix].isReserved = this.seats.includes(row.classId) && !row.isWaiting )
          } else {
            this.blurb = "No upcoming webinars.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  created() {
    this.doLive()
  },
  beforeDestroy () {
    this.loading = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Upcoming.vue